import configs from 'configs';

export const toAbsoluteUrl = (pathname) => configs.publicURL + pathname;
